import { render } from "./PhraseReport.vue?vue&type=template&id=6d92d8e0&scoped=true"
import script from "./PhraseReport.vue?vue&type=script&lang=js"
export * from "./PhraseReport.vue?vue&type=script&lang=js"

import "./PhraseReport.vue?vue&type=style&index=0&id=6d92d8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d92d8e0"]])

export default __exports__